"use strict";

module.exports = require('./register')().Promise;